// ReleaseNote5.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote5 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 5.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing new features and module enhancements across JUNE.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                Patent File Wrapper Downloader{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              Download the complete prosecution history for U.S. patents and
              applications in a single, collated Image File Wrapper.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                EP Bibliographic Data Extraction{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              JUNE now supports bibliographic data extraction for European Patent
              (EP) publications.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                Claims Formatter{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              Automatically clean and standardize claims by updating identifiers,
              removing unwanted formatting, and generating observation reports.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>SB-08 Generator – Enhancement</strong>
              <br />
              The SB-08 Generator now supports DOCX output in addition to the
              existing formats.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>AppGen Module – Enhancement</strong>
            </Typography>
            <ul style={{ margin: "8px 0 0 0", paddingLeft: "5%" }}>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  <strong>Preliminary Amendment documents</strong> for 371 filing
                  packages are now generated automatically.
                </Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  <strong>Initial IDS documents</strong> can now be auto-generated
                  as part of the filing package, with an option to enable or
                  disable IDS generation.
                </Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  <strong>UI Improvements –</strong> The AppGen interface has been
                  reorganized with dedicated upload sections for: Specifications,
                  Drawings, Power of Attorney (POA) &amp; Specification Amendments
                  (371 filings).
                </Typography>
              </li>
            </ul>
          </li>
        </ul>

        <Typography variant="body2" sx={{ mt: 1}}>
          Refer to the FAQ and Tutorial sections for more details on this feature.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote5;
